export default __webpack_public_path__ + "static/media/edit.ab0d23c7.svg";